import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/auth';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: r => require.ensure([], () => r(require('@/pages/login/index.vue')), 'Login'),
      meta: {
        title: '登录 - BeesFPD标准助手'
      }
    },
    {
      path: '/',
      component: r => require.ensure([], () => r(require('@/layouts/MainLayout.vue')), 'MainLayout'),
      redirect: '/compliance-assistant',
      children: [
        {
          path: 'compliance-assistant',
          name: 'ComplianceAssistant',
          component: r => require.ensure([], () => r(require('@/pages/compliance-assistant/index.vue')), 'ComplianceAssistant'),
          meta: {
            title: 'BeesFPD 智能规范助手 - 工程师的标准规范查询工具',
            description: '标准规范·一问直达：内置建/构/给排水/电气/暖通等专业最新规范，提问即可自动定位对应条文与页码。'
          }
        },
        {
          path: 'graph-assistant',
          name: 'GraphAssistant',
          component: r => require.ensure([], () => r(require('@/pages/graph-assistant/index.vue')), 'GraphAssistant'),
          meta: {
            title: 'BeesFPD 智能图例助手 - 工程师的建筑图例搜索工具',
            description: '图集图例·一问直达：内置建/构/给排水/电气/暖通等专业最新图例，提问即可查找匹配的图例图集。'
          }
        },
        {
          path: 'atlas-assistant',
          name: 'AtlasAssistant',
          component: r => require.ensure([], () => r(require('@/pages/atlas-assistant/index.vue')), 'AtlasAssistant'),
          meta: {
            title: 'BeesFPD 标准图集助手 - 建筑图集一问直达',
            description: '标准图集·一问直达：覆盖建筑/消防/给排水/电气/暖通图集，快速检索匹配的标准图集与图例。'
          }
        }
      ]
    },

    {
      path: '*',
      redirect: '/compliance-assistant'
    }
  ]
});

// 白名單：不需要登錄驗證的頁面
// const whiteList = ['/login'];

// 路由守衛 - 只做 token 驗證
router.beforeEach((to, from, next) => {
  console.log('=== 路由守衛開始 ===');
  console.log('從:', from.path || '初始', '→ 到:', to.path);
  console.log('to.matched:', to.matched.length > 0 ? '路由匹配成功' : '路由匹配失敗');

  // 防止無限循環：如果 from 和 to 是同一個路由，直接放行
  if (from.path === to.path && from.path !== '/') {
    console.log('⚠️ 檢測到循環跳轉，強制放行');
    next();
    return;
  }

  // 設置頁面標題
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  // 設置頁面描述（meta description）
  let metaDescription = document.querySelector('meta[name="description"]');
  if (to.meta && to.meta.description) {
    if (metaDescription) {
      // 如果已存在，更新內容
      metaDescription.setAttribute('content', to.meta.description);
    } else {
      // 如果不存在，創建新的 meta 標籤
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      metaDescription.setAttribute('content', to.meta.description);
      document.getElementsByTagName('head')[0].appendChild(metaDescription);
    }
  } else {
    // 如果路由沒有 description，移除或設置默認值
    if (metaDescription) {
      metaDescription.setAttribute('content', 'BeesFPD 智能助手 - 工程师的标准规范和图例查询工具');
    }
  }

  // 獲取 token
  const hasToken = getToken();
  console.log('Token:', hasToken || '無');
  next();
  // if (hasToken) {
  //   // 已登錄
  //   console.log('✓ 已登錄');
  //   if (to.path === '/login') {
  //     console.log('→ 跳轉到合規助手頁');
  //     next({ path: '/compliance-assistant', replace: true });
  //   } else {
  //     console.log('→ 允許訪問');
  //     next();
  //   }
  // } else {
  //   // 未登錄
  //   console.log('✗ 未登錄');
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     console.log('→ 在白名單中，允許訪問');
  //     next();
  //   } else {
  //     console.log('→ 跳轉到登錄頁');
  //     next({ path: '/login', replace: true });
  //   }
  // }
  // console.log('=== 路由守衛結束 ===\n');
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js